// eslint-disable-next-line filenames/match-exported
import { MdOutlineManageAccounts } from "react-icons/md";
import { TbBuilding } from "react-icons/tb";

import { ComponentWithAs, IconProps } from "@chakra-ui/react";

import {
  MembersIcon,
  SettingsToggleIcon,
  UserIcon,
  SubscriptionIcon,
} from "@/components/shared/ReleaseIcons";

export const settingsMenuItems = [
  "Workspace",
  { label: "Details", icon: TbBuilding as ComponentWithAs<"svg", IconProps>, slug: "details" },
  { label: "Members", icon: MembersIcon, slug: "members" },
  {
    label: "Subscription",
    icon: SubscriptionIcon as ComponentWithAs<"svg", IconProps>,
    slug: "subscription",
  },
  { label: "General", icon: SettingsToggleIcon, slug: "general" },
  { label: "Source Control", icon: SettingsToggleIcon, slug: "source_control" },
  "User",
  { label: "My Profile", icon: UserIcon, slug: "profile", basePath: "" },
  { label: "Preferences", icon: SettingsToggleIcon, slug: "preferences", basePath: "/profile" },
  {
    label: "Linked Accounts",
    icon: MdOutlineManageAccounts as ComponentWithAs<"svg", IconProps>,
    slug: "linked_accounts",
    basePath: "/profile",
  },
  // { label: "Notifications", icon: NotificationIcon, slug: "notifications" },
] as const;

type ExtractSlug<T> = T extends { slug: infer S } ? S : never;
export type SettingsMenuItem = ExtractSlug<(typeof settingsMenuItems)[number]>;
